module.exports = __webpack_public_path__ + "static/media/economicalSelect.a6f15841.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/economicalSelect.png
// module id = 78
// module chunks = 0